import { render, staticRenderFns } from "./appraisalCourseDetail.vue?vue&type=template&id=198be5ee"
import script from "./appraisalCourseDetail.vue?vue&type=script&lang=js"
export * from "./appraisalCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./appraisalCourseDetail.vue?vue&type=style&index=0&id=198be5ee&prod&lang=less"
import style1 from "./appraisalCourseDetail.vue?vue&type=style&index=1&id=198be5ee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports